<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        header: 'Location Searches',
        body: [
          `Location searches will perform a SQL search for the specified locations that 
          a user is authorized to access against the Master data.`,
        ],
      },
      {
        header: 'Search Results',
        body: [
          `The results will display the person list which matches the search location 
          criteria. The user may download the person results, add a new person, or filter 
          the data. Drilling into a person takes the user to the Person Information page.`,
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
